import { z } from 'zod'

export const ADMINORGLISTPOST_CONTRACT_VERSION = '1.0.0' as const
export const adminOrgListPostResponseSchema = z.unknown()
export type AdminOrgListPostResponse = z.infer<typeof adminOrgListPostResponseSchema>
